import { createStyles } from "@mantine/emotion";

import { getBarHeight }     from "_common/utils";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	const barHeight = getBarHeight ();

	return {
		mainDonationTabContainer: {
			height         : "100%",
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "space-between"
		},
		diamondSvg: {
			height      : "1.75rem",
			width       : "1.75rem",
			marginRight : "0.5em"
		},
		diamondSvgInFooter: {
			height      : "1.75em",
			width       : "1.75em",
			marginRight : "0.5em"
		},
		footerSection: {
			display        : "flex",
			justifyContent : "space-between",
			alignItems     : "center",
			padding        : "1em",
			borderTop      : `1px solid ${ theme.other.colors.border.primary }`,
			width          : "100%",
			background     : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite
		},
		donationAmountContainer: {
			display    : "flex",
			alignItems : "baseline",
			margin     : "0 0.5rem"
		},
		diamondAmountText: {
			fontSize  : "1.25em",
			alignSelf : "self-end"
		},
		seeTopDonorsBtn: {
			padding    : "1em 2em",
			background : theme.other.paletteNew.rightGradient
		},
		donationMainContentContainer: {
			overflowY : "auto",
			flexGrow  : "1",
			// marginBottom : "1rem",

			[rooterMediaQuery.mobileAndTablet]: {
				height          : `calc((100vh - 56.25vw) - 120px - ${ barHeight }px )`,
				backgroundColor : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryWhite
			}
		},
		donationCommentsContainer: {
			marginTop: "1rem"
		},
		// user comment
		avatarImage: {
			height       : "3rem",
			width        : "3rem",
			borderRadius : "100%",
			objectFit    : "cover"
		},
		userName: {
			color      : "rgb(117, 117, 117)",
			cursor     : "pointer",
			fontSize   : "1.3rem",
			fontWeight : "500",
			display    : "inline-flex",
			alignItems : "center"
		},
		donationGoalImageContainer: {
			padding  : "1rem",
			position : "relative"

		},
		description: {
			textTransform: "capitalize"

		},
		details: {
			display    : "flex",
			marginTop  : "0.5rem",
			alignItems : "center"
		},
		diamondSvgIcon: {
			height      : "15px",
			width       : "15px",
			marginRight : "0.5rem"

		},
		textContainer: {
			top      : "20%",
			right    : "4%",
			width    : "58%",
			position : "absolute"
		},
		editIcon: {
			height     : "25px",
			width      : "25px",
			marginLeft : "0.5rem",
			cursor     : "pointer"
		},
		goalCount: {

		},
		donationReceived: {
			// alignSelf: "end"

		},
		donationUsersContainer: {
			padding: "0 0.75rem"
		},
		footerTitle: {
			fontSize     : "1.25rem",
			marginBottom : "0.5rem"
		},

		donationEmptyViewContainer: {
			background : "inherit",
			height     : "60vh",

			[rooterMediaQuery.mobileAndTablet]: {
				background : theme.other.colors.dialog.secondary,
				height     : `calc((100vh - 56.25vw) - 120px - ${ barHeight }px )`
			},

			[rooterMediaQuery.tablet]: {
				height     : "50vh",
				background : theme.other.colors.dialog.secondary
			}

		},
		menuDropdown: {
			// boxShadow       : theme.other.colors.boxShadow.primary,
			backgroundColor : theme.other.colors.dialog.primary,
			border          : "0",
			minWidth        : "400px"
		}

	};
} );
